var React = require('react');

function Minimal (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("path",{"d":"M0 784.63L175.22 0h93.67l175.22 784.63H331.7L298.64 616H145.47l-33.06 168.63zm277.7-274.4l-55.09-284.32h-2.2L165.3 510.23z","data-name":"Layer 1"})));
}

Minimal.defaultProps = {"viewBox":"0 0 444.11 784.63"};

module.exports = Minimal;

Minimal.default = Minimal;
